import { useTranslator } from "@eo-locale/react";
import { useEffect, useState } from "react";

import { Box, Input, SearchIcon, InputGroup } from "@/storybook-components";
import { setCurrentPage, updateFinder } from "@/redux/features/projects/slice";
import { useAppDispatch, useAppSelector } from "@/redux/store/hooks";
import { FINDER_WIDE } from "../breakpoints";

const SearchFilter = (): JSX.Element => {
  const { translate } = useTranslator();
  const dispatch = useAppDispatch();
  const { finder } = useAppSelector((state) => state.projects);
  const { queryFilter } = useAppSelector((state) => state.projectFinder);
  const { locales } = queryFilter;

  const [searchedText, setSearchedText] = useState("");

  useEffect((): void => {
    setSearchedText(finder.name);
  }, [finder]);

  const handleChange = (value) => {
    dispatch(updateFinder({ name: value }));
    dispatch(setCurrentPage(1));
  };

  return (
    <Box
      p={2}
      minW={0}
      css={{ width: "100%", [FINDER_WIDE]: { width: "40%" } }}
      className="ehq-projectsSearchFilterContainer"
    >
      <InputGroup endElement={<SearchIcon />}>
        <Input
          overflow="hidden"
          value={searchedText}
          aria-label={translate("projectFinder.search.placeholder")}
          placeholder={
            locales["projects.search.placeholder"] ||
            translate("projectFinder.search.placeholder")
          }
          onChange={(e) => handleChange(e.target.value)}
          data-tname="projects-menu-top-search-input"
          className="ehq-projectsSearchFilter"
        />
      </InputGroup>
    </Box>
  );
};

export default SearchFilter;
